<template>
  <b-navbar v-if="user" toggleable="lg" :variant="getLayoutNavbarBg()" class="layout-navbar align-items-lg-center container-p-x">

    <!-- Brand demo (see demo.css) -->
    <b-navbar-brand to="/"><span class="app-brand-logo">
        <img v-if="$cookie.get('language') == 'fr'" :src="require('@/assets/logo_client.png')" style="height:50px;"/>
        <img v-if="$cookie.get('language') == 'en'" :src="require('@/assets/logo_client.png')" style="height:50px;"/>
      </span></b-navbar-brand>

    <!-- Sidenav toggle -->

    <!-- Navbar toggle -->
    <b-navbar-toggle target="app-layout-navbar"></b-navbar-toggle>

    <b-collapse is-nav id="app-layout-navbar">
      <!-- Divider -->

      <b-navbar-nav class="align-items-lg-center ml-auto" style="z-index:150; positon:fixed">

        <b-nav-item>
          <router-link to="/" @click.native="logout()">{{ $t('logout')}}</router-link>
        </b-nav-item>
          <template v-if="user.userprofile.user_type.services.includes('languages')">
        <hr class="d-lg-none w-100 my-2">
        <div class="nav-item d-none d-lg-block text-big font-weight-light line-height-1 opacity-25 mr-3 ml-1">|</div>
        <b-nav-item-dropdown :right="!isRTL" class="demo-navbar-user" v-if="$cookie.get('language') == 'fr'">
        <template slot="button-content">
            <span class="d-inline-flex flex-lg-row-reverse align-items-center align-middle">
              {{ $cookie.get('language') }}
            </span>
        </template>
        <b-dd-item @click="changeLanguage('en')"> &nbsp;en</b-dd-item>
      </b-nav-item-dropdown>
      <b-nav-item-dropdown :right="!isRTL" class="demo-navbar-user" v-if="$cookie.get('language') == 'en'">
          <template slot="button-content">
            <span class="d-inline-flex flex-lg-row-reverse align-items-center align-middle">
                {{ $cookie.get('language') }}
            </span>
          </template>
          <b-dd-item @click="changeLanguage('fr')"> &nbsp;fr</b-dd-item>
        </b-nav-item-dropdown>
          </template>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>
<style>
  .b-navbar {
    z-index:200;
  }
</style>
<script>
import { mapState } from 'vuex';
import { AUTH_LOGOUT } from '../_store/authenticate/actiontypes';
import {SWITCH_LANGUAGE_REQUEST} from "../_store/translation/actiontypes";
export default {

  name: 'app-layout-navbar',

  props: {
    sidenavToggle: {
      type: Boolean,
      default: true
    }
  },
  computed: mapState({ user: state => state.user.user }),
    mounted() {
        if (this.$cookie.get('language') === 'fr' || this.$cookie.get('language') === 'en'){
            this.$i18n.locale = this.$cookie.get('language')
        } else {
            this.$cookie.set('language', 'fr', 300);
            location.reload();
        }

    },
  methods: {
    changeLanguage(language) {
        this.$cookie.set('language', language, 300);
        location.reload();
    },
    logout() {
      this.$store.dispatch(AUTH_LOGOUT)
        .then(response => {
          this.$router.push('/');
        })
    },
    toggleSidenav () {
      this.layoutHelpers.toggleCollapsed()
    },

    getLayoutNavbarBg () {
      return this.layoutNavbarBg
    },
      returnLanguageCookie() {
        return this.$cookie.get('language');
      }
  }
}
</script>
